module.exports = __webpack_public_path__ + "img/pop_tixian_pass.9d36ae5e.png";